import { Component, OnInit } from '@angular/core';
import {environment as ENV} from "../../../environments/environment";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-legacy-container',
  templateUrl: './legacy-container.component.html',
  styleUrls: ['./legacy-container.component.scss']
})
export class LegacyContainerComponent {

    public legacyAddPrefix;
   
    constructor( private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute) {
        this.activatedRoute.params.subscribe((value) => {
            this.loadPage(value.page);
        })
    }

    loadPage(page):void {
        const url = new URL(ENV.legacyRootAddr);
        url.hash = "#"+page;
        url.searchParams.set("nonce", Date.now().toString())
        this.legacyAddPrefix = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
    }
}
